import axiosClient from './axiosClient'
import { REQUEST_BUILDER } from '../constant'

const request = {
  get: (url, params, disabledLoading, disableAutoError) => {
    return axiosClient({
      url: url,
      method: REQUEST_BUILDER.GET,
      ...(params && { params: params }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
    })
  },
  post: (url, data, disabledLoading, disableAutoError) => {
    return axiosClient({
      url: url,
      method: REQUEST_BUILDER.POST,
      ...(data && { data: data }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
    })
  },
  delete: (url, data, disabledLoading, disableAutoError) => {
    return axiosClient({
      url: url,
      method: REQUEST_BUILDER.DELETE,
      ...(data && { data: data }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
    })
  },
  put: (url, data, disabledLoading, disableAutoError) => {
    return axiosClient({
      url: url,
      method: REQUEST_BUILDER.PUT,
      ...(data && { data: data }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
    })
  },
}
export default request
